import { Scope } from './interface'

export default function a8config(scope: Scope) {
    return `
        declare var a8config: { getConfig(key: string) => any; }
    `
}
